<style>
._hcontent {
  height: 40px;
}
</style>
<script>
import axios from "axios";

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
let user = JSON.parse(localStorage.getItem("user"));
/**
 * Register component
 */
export default {
  page: {
    title: "Quản lý lương theo",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader
  },

  data() {
    return {
      columns: [
        {
          label: "Người dùng",
          field: "user.username",
        },

        {
          label: "Tổng đơn",
          field: "n_order",
        },

        {
          label: "Doanh thu",
          field: "total_changer",
        },

        {
          label: "Thu nhập",
          field: "profit",
        },
        {
          label: "Tiền nhận",
          field: "salary",
        },
        {
          label: "Tiền nhận từ thuế",
          field: "tax_keep",
        },
        {
          label: "Thống kê",
          field: "success",
        },
       
      
        {
          label: "Hành động",
          field: "_id",
          width: "80px",
        },
      ],
      rows: [],
      time: null,
      value: null,
    };
  },
  methods: {
    changerRefetch(date, type) {
      axios({
        url: process.env.VUE_APP_SERVER_URL + `/api/salary`,
        method: "post",
        headers: {
          authorization: user.token,
        },
        data: {
          date: this.value,
        },
      }).then(({ data }) => {
        this.rows = data ? data : [];
      });
    },
  },

  async created() {
    if (user) {
      let { data } = await axios({
        url: process.env.VUE_APP_SERVER_URL + "/api/salary",
        method: "post",
        headers: {
          authorization: user.token,
        },
      });

      this.rows = data ? data : [];
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader />

    <div class="mb-5">
      <div>
        <h3 class="h5">Quản lý lương</h3>
        <hr />
      </div>

      <div class="my-2">
        <el-date-picker
          v-model="value"
          type="datetimerange"
          align="right"
          @change="changerRefetch"
          start-placeholder="Ngày tháng bắt đầu"
          end-placeholder="Ngày tháng kết thúc"
        >
        </el-date-picker>
      </div>
      <vue-good-table
        :pagination-options="{
          enabled: true,
          rowsPerPageLabel: 'các mục trong trang',
          nextLabel: 'tiếp',
          prevLabel: 'trước',
          mode: 'records',
          allLabel: 'Tất cả',
        }"
        :line-numbers="true"
        :columns="columns"
        :rows="rows"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == '_id'">
            <button
              type="button"
              @click="
                $router.push({
                  path:
                    '/thong-ke-doanh-so/' + props.row.user._id,
                })
              "
              class="btn btn-outline-info btn-sm"
            >
              <i class="bx bx-show-alt"></i>
            </button>
          </span>

          <span v-else-if="props.column.field == 'success'">
          Thành công :  {{ props.row.success ? props.row.success.norder_success : 0 }}
          <br/>
          Đang vận chuyển :  {{ props.row.delay ? props.row.delay.norder_delay : 0 }}
          <br/>
          Bị hủy :   {{ props.row.faild ? props.row.faild.norder_faild : 0 }}

          </span>
        </template>
      </vue-good-table>
    </div>

    <!-- end row -->
  </Layout>
</template>